import React from 'react';
import PropTypes from 'prop-types';
import { CardFooter, CardFooterLeft, CardFooterRight } from './bootstrap/Card';
import Pagination, { PaginationItem } from './bootstrap/Pagination';
import Select from './bootstrap/forms/Select';
import Option from './bootstrap/Option';
import { useTranslation } from 'react-i18next';

export const PER_COUNT = {
	25: 25,
	50: 50,
	75: 75,
	100: 100,
};

export const dataPagination = (data, currentPage, perPage) =>
	data.filter(
		(i, index) => index + 1 > (currentPage - 1) * perPage && index + 1 <= currentPage * perPage,
	);

const PaginationButtons = ({
	setCurrentPage,
	currentPage,
	showSelector,
	perPage,
	setPerPage,
	totalrows,
	handlefunction,
	label,
}) => {
	const totalItems = totalrows;
	const totalPage = Math.ceil(totalItems / perPage);

	const pagination = () => {
		let items = [];

		let i = currentPage - 1;
		while (i >= currentPage - 1 && i > 0) {
			items.push(
				<PaginationItem
					key={i}
					onClick={() => {
						setCurrentPage(currentPage - 1);
						handlefunction(currentPage - 1);
					}}>
					{i}
				</PaginationItem>,
			);

			i -= 1;
		}

		items = items.reverse();

		items.push(
			<PaginationItem
				key={currentPage}
				isActive
				onClick={() => {
					setCurrentPage(currentPage);
					handlefunction(currentPage);
				}}>
				{currentPage}
			</PaginationItem>,
		);

		i = currentPage + 1;
		while (i <= currentPage + 1 && i <= totalPage) {
			items.push(
				<PaginationItem
					key={i}
					onClick={() => {
						setCurrentPage(currentPage + 1);
						handlefunction(currentPage + 1);
					}}>
					{i}
				</PaginationItem>,
			);

			i += 1;
		}

		return items;
	};

	const getInfo = () => {
		const { t } = useTranslation();
		// const start = perPage * (currentPage - 1) + 1;
		const start = totalrows > 0 ? perPage * (currentPage - 1) + 1 : 0;
		const end = perPage * currentPage;

		return (
			<span className='pagination__desc'>
				{t('Showing')} {start} {t('to')} {end > totalItems ? totalItems : end} {t('of')}{' '}
				{totalItems} {t(label)} {/* i18next-extract-disable-line */}
			</span>
		);
	};

	return (
		<CardFooter style={{ backgroundColor: 'transparent' }}>
			<CardFooterLeft>
				<span className='text-muted'>{getInfo()}</span>
			</CardFooterLeft>

			<CardFooterRight className='d-flex'>
				{totalPage > 1 && (
					<Pagination ariaLabel={label}>
						<PaginationItem
							isFirst
							isDisabled={!(currentPage - 1 > 0)}
							onClick={() => {
								setCurrentPage(1);
								handlefunction(1);
							}}
						/>
						<PaginationItem
							isPrev
							isDisabled={!(currentPage - 1 > 0)}
							onClick={() => {
								setCurrentPage(currentPage - 1);
								handlefunction(currentPage - 1);
							}}
						/>
						{currentPage - 1 > 1 && (
							<PaginationItem
								onClick={() => {
									setCurrentPage(currentPage - 2);
									handlefunction(currentPage - 2);
								}}>
								...
							</PaginationItem>
						)}
						{pagination()}
						{currentPage + 1 < totalPage && (
							<PaginationItem
								onClick={() => {
									setCurrentPage(currentPage + 2);
									handlefunction(currentPage + 2);
								}}>
								...
							</PaginationItem>
						)}
						<PaginationItem
							isNext
							isDisabled={!(currentPage + 1 <= totalPage)}
							onClick={() => {
								setCurrentPage(currentPage + 1);
								handlefunction(currentPage + 1);
							}}
						/>
						<PaginationItem
							isLast
							isDisabled={!(currentPage + 1 <= totalPage)}
							onClick={() => {
								setCurrentPage(totalPage);
								handlefunction(totalPage);
							}}
						/>
					</Pagination>
				)}

				{showSelector && (
					<Select
						size='sm'
						ariaLabel='Per'
						onChange={(e) => {
							setPerPage(parseInt(e.target.value, 10));
							setCurrentPage(1);
							handlefunction(1, parseInt(e.target.value, 10));
						}}
						value={perPage.toString()}>
						{Object.keys(PER_COUNT).map((i) => (
							<Option key={i} value={i}>
								{i}
							</Option>
						))}
					</Select>
				)}
			</CardFooterRight>
		</CardFooter>
	);
};
PaginationButtons.propTypes = {
	setCurrentPage: PropTypes.func.isRequired,
	currentPage: PropTypes.number.isRequired,
	perPage: PropTypes.number.isRequired,
	setPerPage: PropTypes.func.isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	label: PropTypes.string,
};
PaginationButtons.defaultProps = {
	label: 'items',
};

export default PaginationButtons;
